import { normalizePropertyMoney } from "./propertyLoanMoney";
import {
  propertyLoanMonths,
  propertyLoanMonthlyRate,
} from "./propertyLoanProducts";

function repaymentTerms(type, form) {
  const months = propertyLoanMonths(type, form);
  const amount = Math.round(normalizePropertyMoney(form.loanAmount) * 100);
  const interest = Math.round(amount * propertyLoanMonthlyRate(type));
  const instalment = Math.round(amount / months);
  return { months, amount, interest, instalment };
}

export function propertyLoanMonthlyRepayment(type, form) {
  const { amount, interest, instalment } = repaymentTerms(type, form);
  return (
    (interest +
      (form.loanPaymentType === "normal" ? Math.min(amount, instalment) : 0)) /
    100
  );
}

export function buildPropertyLoanRepaymentSchedule(
  type,
  form,
  today = new Date(),
) {
  const { months, amount, interest, instalment } = repaymentTerms(type, form);
  let balance = amount;
  const firstMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
  return Array.from({ length: months }, (_, index) => {
    const last = index === months - 1;
    const principal =
      form.loanPaymentType === "interest"
        ? last
          ? balance
          : 0
        : last
          ? balance
          : Math.min(balance, instalment);
    const row = {
      month: new Date(
        firstMonth.getFullYear(),
        firstMonth.getMonth() + index,
        1,
      ).toLocaleString("default", { month: "long", year: "numeric" }),
      principal: principal / 100,
      interest: interest / 100,
      total: (principal + interest) / 100,
      loanBalance: balance / 100,
    };
    balance -= principal;
    return row;
  });
}
